import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'it',
  months: [
    'gennaio',
    'febbraio',
    'marzo',
    'aprile',
    'maggio',
    'giugno',
    'luglio',
    'agosto',
    'settembre',
    'ottobre',
    'novembre',
    'dicembre',
  ],
  monthsShort: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
  weekdays: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
  weekdaysMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
  weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'DD/MM/YYYY',
    'l-Y': 'DD/MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY HH:mm',
    'lll-Y': 'D MMM HH:mm',
    llll: 'ddd D MMM YYYY HH:mm',
    'llll-Y': 'ddd D MMM HH:mm',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s anno fa', other: '%s anni fa' },
    M: { one: '%s mese fa', other: '%s mesi fa' },
    w: { one: '%s sett. fa', other: '%s sett. fa' },
    d: { one: '%s g fa', other: '%s gg fa' },
    h: { one: '%s h fa', other: '%s h fa' },
    m: { one: '%s min fa', other: '%s min fa' },
    s: { one: '%s sec. fa', other: '%s sec. fa' },
  },
  future: {
    y: { one: 'tra %s anno', other: 'tra %s anni' },
    M: { one: 'tra %s mese', other: 'tra %s mesi' },
    w: { one: 'tra %s sett.', other: 'tra %s sett.' },
    d: { one: 'tra %s g', other: 'tra %s gg' },
    h: { one: 'tra %s h', other: 'tra %s h' },
    m: { one: 'tra %s min', other: 'tra %s min' },
    s: { one: 'tra %s sec.', other: 'tra %s sec.' },
  },
  pastLong: {
    y: { one: '%s anno fa', other: '%s anni fa' },
    M: { one: '%s mese fa', other: '%s mesi fa' },
    w: { one: '%s settimana fa', other: '%s settimane fa' },
    d: { one: '%s giorno fa', other: '%s giorni fa' },
    h: { one: '%s ora fa', other: '%s ore fa' },
    m: { one: '%s minuto fa', other: '%s minuti fa' },
    s: { one: '%s secondo fa', other: '%s secondi fa' },
  },
  futureLong: {
    y: { one: 'tra %s anno', other: 'tra %s anni' },
    M: { one: 'tra %s mese', other: 'tra %s mesi' },
    w: { one: 'tra %s settimana', other: 'tra %s settimane' },
    d: { one: 'tra %s giorno', other: 'tra %s giorni' },
    h: { one: 'tra %s ora', other: 'tra %s ore' },
    m: { one: 'tra %s minuto', other: 'tra %s minuti' },
    s: { one: 'tra %s secondo', other: 'tra %s secondi' },
  },
  abbr: {
    y: { one: '%sanno', other: '%sanni' },
    M: { one: '%sm', other: '%sm' },
    w: { one: '%sset', other: '%sset' },
    d: { one: '%sg', other: '%sg' },
    h: { one: '%so', other: '%so' },
    m: { one: '%smin', other: '%smin' },
    s: { one: '%ss', other: '%ss' },
  },
  full: {
    y: { one: '%s anno', other: '%s anni' },
    M: { one: '%s mese', other: '%s mesi' },
    w: { one: '%s settimana', other: '%s settimane' },
    d: { one: '%s giorno', other: '%s giorni' },
    h: { one: '%s ora', other: '%s ore' },
    m: { one: '%s minuto', other: '%s minuti' },
    s: { one: '%s secondo', other: '%s secondi' },
  },
  justNow: 'Adesso',
  yesterday: 'Ieri',
  today: 'Oggi',
  tomorrow: 'Domani',
  weekStart: 1,
  timeRange: '%$1s - %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'DD', end: 'DD MMMM YYYY' },
    dl: { start: 'DD', end: 'DD MMMM' },
    y: { start: 'DD MMM YYYY', end: 'DD MMM YYYY' },
    'y-1': { start: 'DD MMM', end: 'DD MMM YYYY' },
    m: { start: 'DD MMM', end: 'DD MMM' },
    'm-1': { start: 'DD', end: 'DD MMM YYYY' },
    d: { start: 'DD', end: 'DD MMM' },
    Y: { start: 'ddd D MMM YYYY', end: 'ddd D MMM YYYY' },
    'Y-1': { start: 'ddd D MMM', end: 'ddd D MMM YYYY' },
    M: { start: 'ddd DD MMM', end: 'ddd DD MMM' },
    D: { start: 'ddd DD MMM', end: 'ddd DD MMM' },
    yt: { start: 'DD MMM YYYY HH:mm', end: 'DD MMM YYYY HH:mm' },
    mt: { start: 'DD MMM HH:mm', end: 'DD MMM HH:mm' },
    dt: { start: 'DD MMM HH:mm', end: 'DD MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'DD MMM YYYY HH:mm', end: 'DD MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'DD MMM HH:mm', end: 'DD MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'DD MMM HH:mm', end: 'DD MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'it';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}º`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
